/*
 * @Description:
 * @Author: lz
 * @Date: 2021-09-09 15:51:33
 * @LastEditTime: 2021-09-15 10:14:52
 * @LastEditors: lz
 */
import Cookies from 'js-cookie'
import { getProcessEnv } from './index'

export function setToken(token) {
  return Cookies.set('HB-TOKEN-TEST', token)
}

export function getToken() {
  return getProcessEnv() ? Cookies.get('HB-TOKEN-TEST') || '' : Cookies.get('HB-TOKEN') || ''
}
export function removeToken() {
  return Cookies.remove(getProcessEnv() ? 'HB-TOKEN-TEST' : 'HB-TOKEN')
}
export function getRoutePath() {
  return getProcessEnv() ? 'https://hbtest.gongsibao.com/login?redirect=' : 'https://hb.gongsibao.com/login?redirect='
}
